export const portalUrl: string = "https://tcx-dev-portal-api.azurewebsites.net/api/user/verification"
export const apiKey: string = "a8cb1ee8-e7f4-48e2-8e9c-8835e3ca9d48";
